// extracted by mini-css-extract-plugin
module.exports = {"testo":"markdown-module--testo--p5knm","image":"markdown-module--image--dsRa4","legal":"markdown-module--legal--2gkGP"};